import { WorkflowType } from "../../common/service/server/dto/RegulationRequestTypeDto";

/**
 * Workflow step definitions - shared between request processing (DataRequestProcessingContext)
 * and Workflow Setup pages (HorizontalStepProgressIndicator).
 *
 * Step names use lowercase with spaces to match DataRequestState (e.g. "verify consumer" = VERIFY_CONSUMER).
 */

export const WORKFLOW_STEPS: Record<WorkflowType, string[]> = {
  [WorkflowType.KNOW]: ["verify consumer", "retrieve data", "send data"],
  [WorkflowType.PORTABILITY]: ["verify consumer", "retrieve data", "send data"],
  [WorkflowType.DELETE]: ["verify consumer", "delete info", "contact vendors", "notify consumer"],
  [WorkflowType.OPT_OUT]: ["remove consumer", "contact vendors"],
  [WorkflowType.CORRECTION]: ["verify consumer", "correct data", "notify consumer"],
  [WorkflowType.OBJECTION]: ["verify consumer", "evaluate objection", "notify consumer"],
  [WorkflowType.RESTRICT_PROCESSING]: ["verify consumer", "restrict processing", "notify consumer"],
  [WorkflowType.PIPEDA_WITHDRAW_CONSENT]: [
    "verify consumer",
    "withdraw consent",
    "notify consumer",
  ],
  [WorkflowType.WITHDRAW_CONSENT]: ["verify consumer", "remove consent", "notify consumer"],
  [WorkflowType.US_WITHDRAW_CONSENT]: ["verify consumer", "remove consent", "notify consumer"],
  [WorkflowType.LIMIT]: ["limit data", "contact vendors"],
  [WorkflowType.PROFILING_OPT_OUT]: ["verify consumer", "stop auto profiling", "notify consumer"],
  [WorkflowType.APPEAL]: ["validate appeal", "resolve appeal", "notify consumer"],
  [WorkflowType.PROFILING_INFORMATION]: ["verify consumer", "get profiling info", "send data"],
  [WorkflowType.GPC_OPT_OUT]: [],
  [WorkflowType.BROWSER_OPT_OUT]: [],
};

/** Delete workflow has conditional steps - use contactRequired for setup (full flow) */
export const DELETE_STEPS_CONTACT_REQUIRED = WORKFLOW_STEPS[WorkflowType.DELETE];

export const DELETE_STEPS_NO_CONTACT = [
  "verify consumer",
  "delete info",
  "notify consumer",
] as const;

/**
 * Get step names for a workflow type. For DELETE, returns the full flow with contact vendors.
 */
export function getStepNamesForWorkflowType(workflowType: WorkflowType): string[] {
  return WORKFLOW_STEPS[workflowType] ?? [];
}

/** Steps that are automated - show lightning bolt, not clickable, no step number */
export const AUTOMATED_STEPS = ["verify consumer", "validate appeal"] as const;

export function isAutomatedStep(stepName: string): boolean {
  return (AUTOMATED_STEPS as readonly string[]).includes(stepName);
}

/** Display label for steps - "verify consumer" shown as "consumer lookup" on setup pages */
const STEP_DISPLAY_LABELS: Record<string, string> = {
  "verify consumer": "consumer lookup",
};

export function getStepDisplayLabel(stepName: string): string {
  return STEP_DISPLAY_LABELS[stepName] ?? stepName;
}
